import { getDOMElementByEntityId } from "../utils/DOMUtils";

// print content of the print area element
// creates new page and inserts the html of the selected area
// uses css taken from the current page link elements marked with flag "printcss"="true"
export function printAreaSirenAction(action, widgetId, path) {
    return (dispatch, getState) => {
        let dependencies = action.dependencies || [];
        let printAreaId = dependencies[0];
        let printAreaElement = getDOMElementByEntityId(printAreaId);
        let printCSSLinks = document.querySelectorAll("link[printcss='true']");
        let printWindowTitle = action.title;

        if (!printAreaElement) {
            return Promise.reject("Invalid print area.");
        }

        return printArea(printAreaElement, printCSSLinks, printWindowTitle);
    };
}

function printArea(printAreaElement, printCSSLinks = [], title) {
    let svg = printAreaElement.getElementsByTagName("svg");
    let printWindow = window.open("", "PRINT", "height=1024,width=1280");
    let titleHTML = "";
    let linksHTML = "";
    if (title) {
        titleHTML = `<title>${title}</title>`;
    }

    if (svg.length) {
        svg[0].setAttribute("viewBox", "0 0 1000 148");
        svg[0].setAttribute("preserveAspectRatio", "xMidYMid meet");
    }

    for (let i = 0; i < printCSSLinks.length; i++) {
        linksHTML += printCSSLinks[i].outerHTML;
    }

    printWindow.document.write(`
    <html>
        <head>
            ${titleHTML}
            ${linksHTML}
        </head>
        <body >
            <div id="printAreaElement" style="-webkit-print-color-adjust:exact;">
                ${printAreaElement.outerHTML}
            </div>
        </body>
    </html>`);

    printWindow.document.getElementById("printAreaElement").style.height =
        printAreaElement.offsetHeight;

    printWindow.focus(); // necessary for IE >= 10*/
    setTimeout(function() {
        printWindow.print();
        //close window after print
        printWindow.document.close(); // necessary for IE >= 10
        printWindow.close();
    }, 500);
}
